import React, { Component } from 'react';
import {Container, Row, Col, Card, CardTitle, CardBody, CardFooter, Button, FormGroup, Input, Label} from 'reactstrap';
import { app } from '../../base'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Profile extends Component {
  constructor() {
    super();
    this.state = {
      user_name: '',
      email: '',
      real_name: '',
      shop_name: '',
      city: '',
      province: '',
      neighborhood: '',
      street: '',
      building_no: '',
      door_no: '',
      phone: '',
      shop_location: '',

      edit_disabled: true,
      edit_switch: false,
      message: '',
      show: 'none',
      street_options: [],
      uid: null,
      user_type: 0,
      
      neighborhood_options: [],
      province_options: [],
      city_options: [],
      loc_arr: []
    };
    this.checkUserType();
    this.changeValue = this.changeValue.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.getUserProfile = this.getUserProfile.bind(this);
  }

  componentDidMount() {
    this.createLocationOptions();
  }

  componentWillMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.getPosition);
    }
  }

  changeLocationOptions(item, value) {
    let loc_arr = this.state.loc_arr;
    let province_arr = [], neighborhood_arr = [], street_arr = [];
    let province_options = [], neighborhood_options = [], street_options = [];
    let city, province, neighborhood;
    switch(item){
      case 'city':
        city = this.cityInput.value;
        loc_arr = loc_arr.filter(this.filterLocArr.bind(this, city));
        for (let i = 0, locItem; i < loc_arr.length; i++) {
          locItem = loc_arr[i].split('##');
          if (province_arr.indexOf(locItem[1]) == -1) {
            province_arr.push(locItem[1]);
          }
          if (neighborhood_arr.indexOf(locItem[2]) == -1) {
            neighborhood_arr.push(locItem[2]);
          }
          if (street_arr.indexOf(locItem[3]) == -1) {
            street_arr.push(locItem[3]);
          }
        }

        province_arr.sort();
        neighborhood_arr.sort();
        street_arr.sort();
        for (let i = 0; i < province_arr.length; i++) {
        province_options.push(<option key={i} value={province_arr[i]}>{province_arr[i]}</option>);
        }
        for (let i = 0; i < neighborhood_arr.length; i++) {
          neighborhood_options.push(<option key={i} value={neighborhood_arr[i]}>{neighborhood_arr[i]}</option>);
        }
        for (let i = 0; i < street_arr.length; i++) {
          street_options.push(<option key={i} value={street_arr[i]}>{street_arr[i]}</option>);
        }
        
        this.setState({
          province_options: province_options,
          neighborhood_options: neighborhood_options,
          street_options: street_options
        });
        break;
      case 'province':
        city = this.cityInput.value;
        province = this.provinceInput.value;
        loc_arr = loc_arr.filter(this.filterLocArr.bind(this, city+'##'+province));
        for (let i = 0, locItem; i < loc_arr.length; i++) {
          locItem = loc_arr[i].split('##');
          if (neighborhood_arr.indexOf(locItem[2]) == -1) {
            neighborhood_arr.push(locItem[2]);
          }
          if (street_arr.indexOf(locItem[3]) == -1) {
            street_arr.push(locItem[3]);
          }
        }

        neighborhood_arr.sort();
        street_arr.sort();
        for (let i = 0; i < neighborhood_arr.length; i++) {
          neighborhood_options.push(<option key={i} value={neighborhood_arr[i]}>{neighborhood_arr[i]}</option>);
        }
        for (let i = 0; i < street_arr.length; i++) {
          street_options.push(<option key={i} value={street_arr[i]}>{street_arr[i]}</option>);
        }
        
        this.setState({
          neighborhood_options: neighborhood_options,
          street_options: street_options
        });
        break;
      case 'neighborhood':
        city = this.cityInput.value;
        province = this.provinceInput.value;
        neighborhood = this.neighborhoodInput.value;
        loc_arr = loc_arr.filter(this.filterLocArr.bind(this, city+'##'+province+'##'+neighborhood));
        for (let i = 0, locItem; i < loc_arr.length; i++) {
          locItem = loc_arr[i].split('##');
          if (street_arr.indexOf(locItem[3]) == -1) {
            street_arr.push(locItem[3]);
          }
        }

        street_arr.sort();
        for (let i = 0; i < street_arr.length; i++) {
          street_options.push(<option key={i} value={street_arr[i]}>{street_arr[i]}</option>);
        }
        
        this.setState({
          street_options: street_options
        });
        break;
      default:
        break;
    }
  }

  changeMode(event) {
    this.setState({
      edit_disabled: !event.target.checked,
      edit_switch: event.target.checked
    });
  }

  changeValue(event, item) {
    this.setState({
      [item]: event.target.value
    });

    let locApplied = ["city", "province", "neighborhood"];
    if (locApplied.indexOf(item) != -1) {
      this.changeLocationOptions(item, event.target.value);
    }
  }

  checkUserType() {
    setTimeout(()=>{
      let user_type = sessionStorage.getItem("user_type");
      let uid = sessionStorage.getItem("uid");
      if (uid && user_type) {
        this.setState({
          uid: uid,
          user_type: user_type
        });
        this.getUserProfile();
      }
      else {
        this.checkUserType();
      }
    }, 1000);
  }

  createLocationOptions() {
    app.database().ref('/locations').once('value', (snapshot)=>{
      let loc_arr = [];
      let city_arr = [], province_arr = [], neighborhood_arr = [], street_arr = [];
      let city_options = [], province_options = [], neighborhood_options = [], street_options = [];
      let city, province, neighborhood, street;
      snapshot.forEach((child)=>{
        city = child.val().city;
        province = child.val().province;
        neighborhood = child.val().neighborhood;
        street = child.val().street;

        if (city_arr.indexOf(city) == -1) {
          city_arr.push(city);
        }
        if (province_arr.indexOf(province) == -1) {
          province_arr.push(province);
        }
        if (neighborhood_arr.indexOf(neighborhood) == -1) {
          neighborhood_arr.push(neighborhood);
        }
        if (street_arr.indexOf(street) == -1) {
          street_arr.push(street);
        }
        
        loc_arr.push(city+'##'+province+'##'+neighborhood+'##'+street);
      });

      city_arr.sort();
      province_arr.sort();
      neighborhood_arr.sort();
      street_arr.sort();

      for (let i = 0; i < city_arr.length; i++) {
        city_options.push(<option key={i} value={city_arr[i]}>{city_arr[i]}</option>);
      }
      for (let i = 0; i < province_arr.length; i++) {
        province_options.push(<option key={i} value={province_arr[i]}>{province_arr[i]}</option>);
      }
      for (let i = 0; i < neighborhood_arr.length; i++) {
        neighborhood_options.push(<option key={i} value={neighborhood_arr[i]}>{neighborhood_arr[i]}</option>);
      }
      for (let i = 0; i < street_arr.length; i++) {
        street_options.push(<option key={i} value={street_arr[i]}>{street_arr[i]}</option>);
      }
      
      this.setState({
        city_options: city_options,
        province_options: province_options,
        neighborhood_options: neighborhood_options,
        street_options: street_options,
        loc_arr: loc_arr
      });
    });
  }

  filterLocArr(locStr, element) {
    return element.startsWith(locStr);
  }

  getPosition(position){
    //console.log("Latitude: " + position.coords.latitude + ", Longitude: " + position.coords.longitude);
    this.setState({
      shop_location: position.coords.latitude+','+position.coords.longitude
    });
  }

  getUserProfile() {
    app.database().ref('/users/'+this.state.uid).on('value', (snapshot) => {
      let info = snapshot.val();
      this.setState({
        user_name: info.user_name || this.state.user_name || '',
        email: info.email || this.state.email || '',
        real_name: info.real_name  || this.state.real_name|| '',
        shop_name: info.shop_name  || this.state.shop_name|| '',
        street: info.street || this.state.street || '',
        neighborhood: info.neighborhood || this.state.neighborhood || '',
        building_no: info.building_no || this.state.building_no || '',
        door_no: info.door_no || this.state.door_no || '',
        province: info.province || this.state.province || '',
        city: info.city || this.state.city || '',
        phone: info.phone || this.state.phone || ''
      });
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-1">
                  <Label className="switch switch-text switch-warning float-right">
                    <Input type="checkbox" className="switch-input" onClick={(e)=>this.changeMode(e)} checked={this.state.edit_switch}/>
                    <span className="switch-label" data-on="On" data-off="Off"></span>
                    <span className="switch-handle"></span>
                  </Label>
                </CardBody>
                <CardBody className="p-4">
                  <ShowMessage show={this.state.show} message={this.state.message} />
                  <form onSubmit={(event) => { this.saveProfile(event) }} ref={(form) => { this.entryForm = form }}>
                    {
                      (this.state.user_type >= 1) && 
                      <div>
                        <FormGroup>
                          <Label>Username</Label>
                          <Input disabled type="text" innerRef={(input) => { this.nameInput = input }} onChange={(e) => this.changeValue(e, "user_name")} value={this.state.user_name} required />
                        </FormGroup>
                        <FormGroup>
                          <Label>Email</Label>
                          <Input disabled type="text" innerRef={(input) => { this.emailInput = input }} onChange={(e) => this.changeValue(e, "email")} value={this.state.email} required />
                        </FormGroup>
                      </div>
                    }
                    {
                      (this.state.user_type == 2) && 
                      <FormGroup>
                        <Label>Shop Name</Label>
                        <Input disabled={this.state.edit_disabled} type="text" innerRef={(input) => { this.shopNameInput = input }} onChange={(e) => this.changeValue(e, "shop_name")} value={this.state.shop_name} required />
                      </FormGroup>
                    }
                    {
                      (this.state.user_type > 1) &&
                      <div>
                        <FormGroup>
                          <Label>Real Name</Label>
                          <Input disabled={this.state.edit_disabled} type="text" innerRef={(input) => { this.realNameInput = input }} onChange={(e) => this.changeValue(e, "real_name")} value={this.state.real_name} required />
                        </FormGroup>

                        <FormGroup>
                          <Label>City</Label>
                          <Input disabled={this.state.edit_disabled} type="select" innerRef={(input) => { this.cityInput = input }} onChange={(e) => this.changeValue(e, "city")} value={this.state.city} required>
                            <option value="">Select City</option>
                            {this.state.city_options}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label>Province</Label>
                          <Input disabled={this.state.edit_disabled} type="select" innerRef={(input) => { this.provinceInput = input }} onChange={(e) => this.changeValue(e, "province")} value={this.state.province} required>
                            <option value="">Select Province</option>
                            {this.state.province_options}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label>Neighborhood</Label>
                          <Input disabled={this.state.edit_disabled} type="select" innerRef={(input) => { this.neighborhoodInput = input }} onChange={(e) => this.changeValue(e, "neighborhood")} value={this.state.neighborhood} required>
                            <option value="">Select Neighborhood</option>
                            {this.state.neighborhood_options}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label>Street</Label>
                          <Input disabled={this.state.edit_disabled} type="select" innerRef={(input) => { this.streetInput = input }} onChange={(e) => this.changeValue(e, "street")} value={this.state.street} required>
                            <option value="">Select Street</option>
                            {this.state.street_options}
                          </Input>
                        </FormGroup>

                        <FormGroup>
                          <Label>Building No</Label>
                          <Input disabled={this.state.edit_disabled} type="text" innerRef={(input) => { this.buildingnoInput = input }} onChange={(e) => this.changeValue(e, "building_no")} value={this.state.building_no} required />
                        </FormGroup>

                        <FormGroup>
                          <Label>Door No</Label>
                          <Input disabled={this.state.edit_disabled} type="text" innerRef={(input) => { this.doornoInput = input }} onChange={(e) => this.changeValue(e, "door_no")} value={this.state.door_no} required />
                        </FormGroup>
                      </div>
                    }
                    {
                      (this.state.user_type >= 1) && 
                      <FormGroup>
                        <Label>Phone</Label>
                        <Input disabled={this.state.edit_disabled} type="text" innerRef={(input) => { this.phoneInput = input }} onChange={(e) => this.changeValue(e, "phone")} value={this.state.phone} required />
                      </FormGroup>
                    }
                    {
                      (this.state.user_type == 2) && 
                      <FormGroup>
                        <Label>
                        <Input disabled={this.state.edit_disabled} type="checkbox" innerRef={(input) => { this.locationCheck = input }} />
                        Position (Check if you want to save your shop location)</Label>
                        <Input disabled type="text" innerRef={(input) => { this.shopLocationInput = input }} onChange={(e) => this.changeValue(e, "shop_location")} value={this.state.shop_location} required />
                      </FormGroup>
                    }
                    <Button block color="success"  disabled={this.state.edit_disabled}>Save</Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </div>
    )
  }

  saveProfile(event) {
    event.preventDefault();
    let user_name, email, real_name, shop_name, city, province, neighborhood, street, building_no, door_no, phone, locationCheck = false, shop_location;

    //user_name = this.nameInput.value
    //email = this.emailInput.value
    if (this.state.user_type == 2) {
      shop_name = this.shopNameInput.value
      locationCheck = this.locationCheck.checked
      shop_location = this.shopLocationInput.value
    }
    if (this.state.user_type > 1) {
      real_name = this.realNameInput.value
      city = this.cityInput.value
      province = this.provinceInput.value
      neighborhood = this.neighborhoodInput.value
      street = this.streetInput.value
      building_no = this.buildingnoInput.value
      door_no = this.doornoInput.value
    }
    phone = this.phoneInput.value
    //console.log(name+"-"+email+"-"+real_name+"-"+street+'-'+shop_location)

    if (user_name == '' || email == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    let dbObj = {};
    //dbObj.user_name = user_name;
    //dbObj.email = email;
    dbObj.phone = phone;

    if (this.state.user_type > 1) {
      dbObj.real_name = real_name;
      dbObj.city = city;
      dbObj.province = province;
      dbObj.neighborhood = neighborhood;
      dbObj.street = street;
      dbObj.building_no = building_no;
      dbObj.door_no = door_no;
    }

    if (this.state.user_type == 2) {
      dbObj.shop_name = shop_name;
    }
    if (locationCheck) {
      dbObj.position = shop_location;
    }

    app.database().ref('users/' + this.state.uid).update(dbObj).then(()=>{
      this.setMessage("Information updated");
      this.setState({
        edit_disabled: true,
        edit_switch: false
      });
      window.scrollTo(0, 0);
    }).catch((error)=>{
      this.setMessage(error.message);
      window.scrollTo(0, 0);
    });
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/views/Users/Profile.js